import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Box, Button, Chip } from "@mui/material";

const DeliveryTripDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation() as any;
  const trip = state?.trip || {};

  const statusLabel = (s: string) => (s === 'ON_TIME' ? 'On-Time' : s === 'DELAYED' ? 'Delayed' : 'Completed');
  const statusColor = (s: string) => (s === 'ON_TIME' ? 'success' : s === 'DELAYED' ? 'warning' : 'default');

  return (
    <>
      <div className="main_title">
        <h1>Trip Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - {" "}
          <button onClick={() => navigate("/delivery")}>Delivery Tracking</button> - Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="table_header">
          <h2>Overview</h2>
        </div>
        <div className="gap_p">
          <div className="w_33">
            <h6>Booking ID</h6>
            <p>{trip?.bookingId || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Customer</h6>
            <p>{trip?.customer || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Project</h6>
            <p>{trip?.project || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Vehicle</h6>
            <p>{trip?.vehicle || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Driver</h6>
            <p>{trip?.driver || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Status</h6>
            <p>
              <Chip size="small" label={statusLabel(trip?.status)} color={statusColor(trip?.status)} />
            </p>
          </div>
          <div className="w_33">
            <h6>Last Location</h6>
            <p>{trip?.lastLocation || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Speed</h6>
            <p>{trip?.speedKph != null ? `${trip?.speedKph} km/h` : '-'}</p>
          </div>
          <div className="w_33">
            <h6>ETA</h6>
            <p>{trip?.eta || '-'}</p>
          </div>
        </div>
      </div>

      <div className="cards view_page">
        <div className="table_header">
          <h2>Live Map</h2>
        </div>
        {/* Live Map */}
        <Box sx={{ height: 280, borderRadius: 2, overflow: 'hidden', mb: 2, border: '1px solid #e2e8f0' }}>
          <iframe
            title="Delivery Live Map"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d57818.468889342306!2d55.2708!3d25.2048!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sAE!4v1700000000000"
          />
        </Box>
      </div>

      <div className="cards view_page">
        <div className="table_header">
          <h2>Linked Booking</h2>
          <div className="right_s">
            {trip?.bookingId && (
              <Button className="btn btn_outline sm" onClick={() => navigate(`/bookings`, { state: { from: 'delivery' } })}>Go to Bookings</Button>
            )}
          </div>
        </div>
        <div className="gap_p">
          <div className="w_33">
            <h6>Booking Reference</h6>
            <p>{trip?.bookingId || '-'}</p>
          </div>
        </div>
      </div>

      <div className="cards view_page">
        <div className="table_header">
          <h2>Alerts & Exceptions</h2>
        </div>
        <div className="gap_p">
          <div className="w_33"><h6>Delay</h6><p>—</p></div>
          <div className="w_33"><h6>Route Deviation</h6><p>—</p></div>
          <div className="w_33"><h6>Breakdowns</h6><p>—</p></div>
        </div>
      </div>

      <div className="cards view_page">
        <div className="table_header">
          <h2>History</h2>
        </div>
        <Box sx={{ p: 2, color: '#64748b' }}>Completed delivery logs placeholder</Box>
      </div>
    </>
  );
};

export default DeliveryTripDetailPage;
